import { Component, Input } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';

@Component({
  moduleId: module.id,
  selector: 'site-filmSideMenu',
  templateUrl: './filmSideMenu.component.html',
  styleUrls: ['./filmSideMenu.component.css']
})
export class FilmSideMenuComponent {
  private fragment: string;
  
  constructor(private route: ActivatedRoute, private router: Router) {

  this.router.events.subscribe(s => {
    if (s instanceof NavigationEnd) {
      const tree = router.parseUrl(router.url);
      if (tree.fragment) {
        const element = document.querySelector("#" + tree.fragment);
        if (element) { element.scrollIntoView(true); }
      }
    }
  });
 }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }

  ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
    } catch (e) { }
  }

  @Input()
  filmLength: string;

  @Input()
  filmName: string;

  @Input()
  releaseDate: Date;

  @Input()
  MPAARating: String;

  @Input()
  director: String;

  @Input()
  paulStars: String;

  @Input()
  paulGrade: String;

  @Input()
  filmSideMenuItem1: string;

  @Input()
  filmSideMenuItem2: string;

  @Input()
  filmSideMenuItem2b: string;

  @Input()
  filmSideMenuItem3: string;

  @Input()
  filmSideMenuItem3b: string;

  @Input()
  filmSideMenuItem4: string;

  @Input()
  filmSideMenuItem5: string;

  @Input()
  filmSideMenuItem6: string;

  @Input()
  filmSideMenuItem7: string;

  @Input()
  filmSideMenuItem8: string;

  @Input()
  posterImage: string;

  
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/filmSideMenu/filmSideMenu.component.ts